import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import ModalDialog from '../../../common/modal-dialog/modal-dialog.component';
import { Description, Header } from './no-delivery-option-modal.styles';
import Button from '../../../common/button/button.component';
import { useStore } from '../../../stores/store';
import { isCountryWithZip } from '../../parcel-creation/delivery-details-form/delivery-details-form.component';
import { FlexContainer } from '../../../common/flex-container/flex-container.styles';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

const NoDeliveryOptionModal = ({ isOpen = false, onClose, message }: Props) => {
  const {
    parcelCreationStore: { setNoDeliveryOptionAvailable, countryDeparture },
  } = useStore();

  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
    setNoDeliveryOptionAvailable(false);
  };

  return (
    <ModalDialog
      onClose={handleClose}
      isOpen={isOpen}
      width='40rem'
      paddingMobile='3.2rem'
      displayButtons={false}>
      <Header>{t('reprice_header_no_delivery_option')}</Header>
      <Description>
        {isCountryWithZip(countryDeparture?.code)
          ? t('reprice_message_usa')
          : t('reprice_message')}
      </Description>
      <FlexContainer $justify='flex-end'>
        <Button
          $mb='1.6rem'
          onClick={handleClose}
          fullWidth={false}>
          {t('okay')}
        </Button>
      </FlexContainer>
    </ModalDialog>
  );
};

export default observer(NoDeliveryOptionModal);
